import { render, staticRenderFns } from "./VaimoCrossSellProduct.vue?vue&type=template&id=047e13d8&scoped=true&"
import script from "./VaimoCrossSellProduct.vue?vue&type=script&lang=ts&"
export * from "./VaimoCrossSellProduct.vue?vue&type=script&lang=ts&"
import style0 from "./VaimoCrossSellProduct.vue?vue&type=style&index=0&id=047e13d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047e13d8",
  null
  
)

export default component.exports